<template>
  <div ref="tableBox">
    <div class="filter-list">
      <div class="filter-item">
        <div class="item-label">
          状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper">
            <el-select v-model="status.value" placeholder="请选择" clearable @change="buildData">
              <el-option v-for="item in status.options" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="filter-item">
        <div class="item-label">
          部门
        </div>
        <div class="item-component">
          <div class="el-select-wrapper">
            <el-select v-model="deptId" placeholder="请选择" clearable @change="buildData" :disabled="deptDisable">
              <el-option v-for="item in deptOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column type="index" width="20px" label="#"></el-table-column>
      <el-table-column property="typeText" label="类型" width="80px"></el-table-column>
      <el-table-column property="summary" label="主题" min-width="200px" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" target="_blank"
                   :href="$util.buildSmsActivityDetailUrl(scope.row.actId)">
            {{ scope.row.summary }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column property="description" label="详情描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventTypeText" label="事件类型" width="120px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventReasonText" label="事件原因" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventLevelText" label="严重等级" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="safetyMeasures" label="安全措施" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="statusText" label="状态" width="65px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="reportTime" label="报告时间" width="120px" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <div class="page-wrapper">
      <el-pagination background layout="prev, pager, next" :total="page.total" :current-page.sync="page.num"
                     :page-size.sync="page.size">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getRequest, postRequest} from "../../../utils/request";

export default {
  props: {
    kpiCode: String,
    company: String,
    year: Number,
    month: Number,
    //初始部门值
    initialDeptId: Number,
    //可选部门值
    deptIds: Array,
    //禁用部门选项
    deptDisable: Boolean,
  },
  data() {
    return {
      //表格数据
      tableData: [],
      //分页
      page: {
        num: 1,
        size: 5,
        total: null,
      },
      //状态
      status: {
        options: [{
          code: "FINISH",
          name: "结案"
        }, {
          code: "CLOSED",
          name: "关闭"
        }, {
          code: "INPROGRESS",
          name: "处理中"
        }],
        value: null
      },
      //部门
      deptId: this.initialDeptId,
      deptOptions: [],
    }
  },
  mounted() {
    this.buildData();
    this.buildDeptOptions();
  },
  methods: {
    buildDeptOptions() {
      postRequest("/org/list", {
        ids: this.deptIds
      }).then(res => {
        this.deptOptions = res.data;
      })
    },
    /**
     * 构建表格数据
     */
    buildData() {
      getRequest(`/result/error/detail/${this.year}`, {
        kpi: this.kpiCode,
        company: this.company,
        month: this.month,
        status: this.status.value,
        dept: this.deptId,
        pageNum: this.page.num,
        pageSize: this.page.size
      }, this.$refs.tableBox).then(res => {
        this.tableData = res.data.records
        this.page.total = res.data.total
      })
    },
  },
  watch: {
    "page.num"() {
      this.buildData();
    },
  }
}
</script>

<style scoped lang="less">
.page-wrapper {
  text-align: center;
  margin-top: 10px;
}

.filter-list {
  .filter-item:not(:first-child) {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/SeriousErrorDetail.vue